export default __webpack_public_path__ + "static/why_choose-e0905231eb3cb379b5511093d0b9d365.webp";